import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import Toggle from "../../components/Toggle";
import Button from "../Button";
import InfoAndText from "../ManageOutlet/InfoAndText";
import { Colors } from "../../config/Constants";

type HeaderProps = {
  onBack: (value: any) => void;
  isEdit: boolean;
  data: any;
  onToggle: any;
};

const ManagePrivilegeAccountHeader = ({
  isEdit,
  onBack,
  data,
  onToggle,
}: HeaderProps) => {
  return (
    <StyledDiv>
      <StyledAccountHeader>
        <BackButtonWrapper>
          <Button label="Back" isRounded={true} onClick={onBack} />
        </BackButtonWrapper>
        <StyledPageHeader>
          {isEdit ? "Edit Privilege Account" : "Add Privilege Account"}
        </StyledPageHeader>
      </StyledAccountHeader>
      <InfoWrapper>
        <InfoAndText text="(This toggle is to activate and deactivate the Account)" />
        <StyledStatus>
          Status:
          <Toggle
            uniqueName={"isActive"}
            isChecked={data.isActive}
            onChange={() =>
              onToggle({ target: { name: "isActive", value: !data.isActive } })
            }
          />
          <ActiveDeactive status={data.isActive}>
            {data.isActive ? "Active" : "Inactive"}
          </ActiveDeactive>
        </StyledStatus>
      </InfoWrapper>
    </StyledDiv>
  );
};

interface StatusProps {
  status: boolean;
}

const StyledAccountHeader = styled.div`
  display: flex;
  padding-bottom: 1rem;
  align-items: center;
  gap: 1rem;
  @media only screen and (max-width: 768px) {
    padding-bottom: 0;
    width: 100%;
  }
`;

const BackButtonWrapper = styled.div`
  width: 120px;
  @media only screen and (max-width: 768px) {
    padding: 1rem;
  }
`;

const StyledPageHeader = styled.div`
  font-size: 1.25rem;
  font-family: "Poppins-Medium";
  line-height: 1.75rem;
  @media only screen and (max-width: 768px) {
    display: none;
  }
`;

export const StyledDiv = styled.div`
  display: flex;
  justify-content: space-between;
  @media only screen and (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const ActiveDeactive = styled.div<StatusProps>`
  color: ${(props) => (props.status ? Colors.appleGreen : Colors.appleRed)};
  width: 6rem;
`;

export const StyledStatus = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  font-size: 0.8rem;
`;

export const InfoWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  @media only screen and (max-width: 768px) {
    flex-direction: column-reverse;
    align-items: flex-start;
    padding: 1rem 1rem 0 1rem;
    width: 100%;
    box-sizing: border-box;
    gap: 0.5rem;
  }
`;

export default ManagePrivilegeAccountHeader;
